import React from 'react';
import { Badge, Tooltip } from '@leapeasy/ui-kit';
import styled from 'styled-components';
import {
  getInviteTypeMeta,
  getRequestStatusMeta,
  getRoleBadgeColor,
  getRoleLabel,
} from './notificationTableConstants';

export const RoleBadge = ({ role, textSize = 'medium' }) => (
  <Badge
    background="#F3F1F4"
    color={getRoleBadgeColor(role)}
    label={getRoleLabel(role)}
    rounded
    textSize={textSize}
  />
);

export const InviteTypeBadge = ({ value }) => {
  const meta = getInviteTypeMeta(value);
  return (
    <Badge color={meta?.badge || 'neutral'} label={meta?.text || value} rounded textSize="medium" />
  );
};

export const RequestStatusBadge = ({ value }) => {
  const meta = getRequestStatusMeta(value);
  return <Badge color={meta.badge} label={meta.text} rounded textSize="medium" />;
};

export const EmailTextCell = ({ html }) => {
  if (!html) return null;
  const plain = String(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return (
    <Tooltip title={plain} placement="top" showCarot>
      <EmailTextWrap dangerouslySetInnerHTML={{ __html: html }} />
    </Tooltip>
  );
};

const EmailTextWrap = styled.div`
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #2e0f40;

  p {
    margin: 0;
    display: inline;
  }
`;
